module.exports = __webpack_public_path__ + "media/images/amenities_icons/library-7dd1de81a2abc6b5ba221daa27777ae3.svg";